module.exports = __webpack_public_path__ + "static/media/ipad_10_9_inch_air_pink.4c6e652d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/ipad_10_9_inch_air_pink.png
// module id = 2106
// module chunks = 0